import { SERVICED_STATES } from "./content";
// Centralised constants for the intake form
export const US_STATES = [
  { v: "AL", l: "Alabama" }, { v: "AK", l: "Alaska" }, { v: "AZ", l: "Arizona" },
  { v: "AR", l: "Arkansas" }, { v: "CA", l: "California" }, { v: "CO", l: "Colorado" },
  { v: "CT", l: "Connecticut" }, { v: "DE", l: "Delaware" }, { v: "FL", l: "Florida" },
  { v: "GA", l: "Georgia" }, { v: "HI", l: "Hawaii" }, { v: "ID", l: "Idaho" },
  { v: "IL", l: "Illinois" }, { v: "IN", l: "Indiana" }, { v: "IA", l: "Iowa" },
  { v: "KS", l: "Kansas" }, { v: "KY", l: "Kentucky" }, { v: "LA", l: "Louisiana" },
  { v: "ME", l: "Maine" }, { v: "MD", l: "Maryland" }, { v: "MA", l: "Massachusetts" },
  { v: "MI", l: "Michigan" }, { v: "MN", l: "Minnesota" }, { v: "MS", l: "Mississippi" },
  { v: "MO", l: "Missouri" }, { v: "MT", l: "Montana" }, { v: "NE", l: "Nebraska" },
  { v: "NV", l: "Nevada" }, { v: "NH", l: "New Hampshire" }, { v: "NJ", l: "New Jersey" },
  { v: "NM", l: "New Mexico" }, { v: "NY", l: "New York" }, { v: "NC", l: "North Carolina" },
  { v: "ND", l: "North Dakota" }, { v: "OH", l: "Ohio" }, { v: "OK", l: "Oklahoma" },
  { v: "OR", l: "Oregon" }, { v: "PA", l: "Pennsylvania" }, { v: "RI", l: "Rhode Island" },
  { v: "SC", l: "South Carolina" }, { v: "SD", l: "South Dakota" }, { v: "TN", l: "Tennessee" },
  { v: "TX", l: "Texas" }, { v: "UT", l: "Utah" }, { v: "VT", l: "Vermont" },
  { v: "VA", l: "Virginia" }, { v: "WA", l: "Washington" }, { v: "WV", l: "West Virginia" },
  { v: "WI", l: "Wisconsin" }, { v: "WY", l: "Wyoming" }, { v: "DC", l: "District of Columbia" },
];

export const ACCIDENT_TYPES = [
  "Auto Accident",
  "Slip / Trip Fall",
  "Medical Malpractice",
  "Premises Liability",
  "Other",
];

export const INTAKE_STEPS = [
  { id: 1, label: "Funding", title: "How much do you need?", description: "Choose the amount you're requesting today." },
  { id: 2, label: "About you", title: "Tell us about you", description: "Basic personal information for verification." },
  { id: 3, label: "Prior funding", title: "Any prior funding?", description: "If you've worked with another funder on this case." },
  { id: 4, label: "Your case", title: "About your case", description: "Help us understand what happened." },
  { id: 5, label: "Your attorney", title: "Your attorney", description: "Who's representing you?" },
  { id: 6, label: "Review & sign", title: "Review & submit", description: "Confirm your details and sign." },
];

export const SERVED_STATE_CODES = US_STATES.filter((s) => SERVICED_STATES.includes(s.l)).map((s) => s.v);
export const stateName = (abbr) => US_STATES.find((s) => s.v === abbr)?.l || abbr;
